const showInternalBrowser = adapter => url => {
  return adapter.callAction('showInternalBrowser', { url })
}

export default showInternalBrowser
